import {createSlice} from "@reduxjs/toolkit"
const archiveSlice = createSlice({
    name:"archive",
    initialState: {archive: false},
    reducers:{
        changeArchiveState : (state, action) =>{
            state.archive = action.payload
        }
    }
})


export const { changeArchiveState } = archiveSlice.actions

export default archiveSlice.reducer

export const selectArchive = state=>state.archive